/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { formatPhoneNumber } from '../../utils/formater';

const Address = (props) => {
    // eslint-disable-next-line object-curly-newline
    const { recipient, countries, onEdit, onRemove, className } = props;
    const { Addresses, AddressBookEntryId } = recipient;
    const recipientAddresses = Addresses.filter((a) => a.AddressType !== 'Billing');
    // const recipientAddresses = [...Addresses];
    return recipientAddresses.map((address) => (
        <React.Fragment key={address.AddressId}>
            <div className={className}>
                <div className="split">
                    <div className="bold">
                        {recipient.FirstName} {recipient.LastName}
                    </div>
                    <div className="flex-none">
                        <button
                            type="button"
                            data-test="my-account-edit-address"
                            className="edit-recipient-btn link margin-right"
                            onClick={() => onEdit(
                                recipient,
                                AddressBookEntryId,
                                address.AddressId,
                            )}
                        >
                            Edit
                        </button>{' '}
                        <button
                            type="button"
                            data-test="my-account-remove-address"
                            className="remove-recipient-btn link"
                            onClick={() => onRemove(recipient, address.AddressId, 'ADDRESS_BOOK')}
                        >
                            Delete
                        </button>
                    </div>
                </div>
                <div>{address.AddressType !== 'Residence' && address.AddressType !== 'Apartment'  ? recipient.EmployerName : null}</div>
                <div>
                    {address.AddressLineOne}
                    {address.AddressLineTwo
                        ? `, ${address.AddressLineTwo}`
                        : ''}
                </div>
                <div>
                    {[
                        address.City,
                        address.StateProvince,
                        address.PostalCode,
                    ].join(', ')}
                </div>
                <div>
                    {countries.findIndex((c) => c.id === address.Country) > -1
                        ? countries.filter((c) => c.id === address.Country)[0]
                            .name
                        : countries.filter((c) => c.id === 'US')[0].name}
                </div>
                <div>{formatPhoneNumber(recipient.PhoneNumber)}</div>
            </div>
        </React.Fragment>
    ));
};

Address.defaultProps = {
    className: '',
};

Address.propTypes = {
    className: PropTypes.string,
    recipient: PropTypes.object.isRequired,
    onEdit: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
};

export default Address;
